import { EnumsService, EnumsFilter, BaseTLTableComponent, AxiosResponse, checkBoxToString, NotificationTemplateService, NotificationTemplateFilter, BaseTLTableBase } from "../../../Infrastructure/CorBase/CoreBase";

export default abstract class NotificationTemplateListBase extends BaseTLTableComponent {

	protected selectedNotificationTemplateId: number = 0;

	protected notificationTemplateService: NotificationTemplateService = new NotificationTemplateService();
	enumService: EnumsService = new EnumsService();

	callActionClick() {
		this.isBusy = true;
		this.deleteItemsList = this.getSelectedList();
		super.deleteList();
		this.itemsSelected = null;
		(this.$refs.notificationTemplateTable as BaseTLTableBase).clearSelected();
	}

	protected deleteListServer(): Promise<AxiosResponse<any>> {
		return this.notificationTemplateService.deleteList(this.deleteItemsList);
	}

	protected contentModal = this.$t('notificationTemplate.messageQuestionMain').toString();

	protected showAlertBeforeDeleteBase(itemsSelected: any) {
		var idNotificationTemplate = Number(itemsSelected);
		this.notificationTemplateService.getById(idNotificationTemplate).then(res => {
			var content = this.$t('notificationTemplate.messageQuestionMain').toString();
			if (res.data.existSchoolYear > 0) {
				content = this.$t('notificationTemplate.messageQuestionDelete1').toString();
			}
			this.contentModal = content;
			this.showAlertBeforeActionClickBase(itemsSelected, content);
		});
	}

	searchAll = [{ id: 1, text: 'test', identifier: 'sdfsdf' }];

	initEnum() {
		this.searchAll = [];
		var filter = new EnumsFilter(null, 'ENU_COR_NotificationTemplate_IvyScreen');
		this.enumService.getAllByFilter(filter).then(res => {
			for (var i = 0; i < res.data.length; i++) {
				this.searchAll.push({ id: res.data[i].id, text: res.data[i].name, identifier: res.data[i].identifier });
			}
		});
	}


	protected showAllertToDeleteClickListBase(itemsSelected: any) {
		this.contentModal = this.$t('notificationTemplate.messageQuestionMain').toString();
		var existWithYear = this.tableData.filter((c: any) => c.existSchoolYear == true && (itemsSelected as Array<any>).indexOf(c.id) != -1).length > 0;

		if (existWithYear == true) {
			this.contentModal = this.$t('notificationTemplate.messageQuestionDelete2').toString();
		}
		this.showAlertBeforeActionClickBase(itemsSelected, this.contentModal,true);
	}

	itemsFilter = [
		{ value: this.$t('global.answerYes').toString(), text: this.$t('global.answerYes').toString() },
		{ value: this.$t('global.answerNo').toString(), text: this.$t('global.answerNo').toString() }];

	protected setFields() {
		this.fields = [
			//	{ key: 'id', label: this.$t('notificationTemplate.fieldIdentif'), trans: 'notificationTemplate.fieldIdentif', sortable: true, class: 'text-center' },
			{ key: 'identifier', label: this.$t('notificationTemplate.fieldIdentifier'), trans: 'notificationTemplate.fieldIdentifier', sortable: true, class: 'text-left', visible: true, optional: true },
			//{ key: 'subjectText', label: this.$t('notificationTemplate.fieldSubject'), trans: 'notificationTemplate.fieldSubject', sortable: true, class: 'text-left', tooltip: 'subjectTooltip', design: 'tooltip', minLengthToShowTooltip: 1 },

			{ key: 'subjectText', label: this.$t('notificationTemplate.fieldSubject'), trans: 'notificationTemplate.fieldSubject', sortable: true, class: 'text-left' },

			//	{ key: 'idTemplateTypeName', label: this.$t('notificationTemplate.fieldType'), trans: 'notificationTemplate.fieldType', sortable: true, class: 'text-left' },
		//	{ key: 'studentIsInDebtText', label: this.$t('notificationTemplate.fieldStudentDebt'), trans: 'notificationTemplate.fieldStudentDebt', sortable: true, class: 'text-left' },
		//	{ key: 'inPriceListText', label: this.$t('notificationTemplate.fieldInPrice'), trans: 'notificationTemplate.fieldInPrice', sortable: true, class: 'text-left' },
			//	{ key: 'sendAddress', label: this.$t('notificationTemplate.fieldAddress'), trans: 'notificationTemplate.fieldAddress', sortable: true, class: 'text-center' },
			{ key: 'actions', label: this.$t('notificationTemplate.fieldAction'), trans: 'notificationTemplate.fieldAction', class: 'text-right', thClass: 'lastColumnMichael' }
		]
	};

	protected setfilters(value: any) {
		if (value != null) {
			this.filters = value;
		}
		else {
			this.filters = [
				{ key: 'subjectText', label: this.$t('notificationTemplate.fieldSubject'), trans: 'notificationTemplate.fieldSubject', selected: false, value: null, type: 'text' },
				{ key: 'idTemplateTypeName', label: this.$t('notificationTemplate.fieldType'), trans: 'notificationTemplate.fieldType', selected: false, value: null, type: 'text', enum: 'ENU_COR_NotificationTemplate_Type', useEnum: true, refItem: 'idTemplateTypeName'},
				{ key: 'studentIsInDebtText', label: this.$t('notificationTemplate.fieldStudentDebt'), selected: false, value: null, type: 'text', useOwnEnumsSend: true, useOwnEnumsSendArray: this.itemsFilter },
				{ key: 'inPriceListText', label: this.$t('notificationTemplate.fieldInPrice'), selected: false, value: null, type: 'text', useOwnEnumsSend: true, useOwnEnumsSendArray: this.itemsFilter }
			];
		}
	}


	protected fetchData() {
		super.fetchData();
	}

	protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
		let notificationTemplateFilter: NotificationTemplateFilter = new NotificationTemplateFilter(null, null,'ENU_NotificationTemplate_IvyScreen_Template');
		return this.notificationTemplateService.getAllByFilter(notificationTemplateFilter);
	}

	//zat�m nepotrebujeme
	fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
		return this.fetchDataFromServer();
	}

	refreshItems(items: any[], refreshData: any[]) {
		return items;
	}

	prepareAfterLoad(inputText: string) {
		for (var i = 0; i < this.searchAll.length; i++) {
			inputText = inputText.split('@' + this.searchAll[i].identifier).join('@' + this.searchAll[i].text);
		}
		return inputText;
	}

	prepareHtml(items: string) {
		var result = "<div>" + items + "<br/></div>";
		return result;
	}

	protected prepareItems(items: any[]) {
		for (var i = 0; i < items.length; i++) {
			var prepare = this.prepareAfterLoad(items[i].subjectDtb);
			items[i].subjectTooltip = prepare.length> 17 ?this.prepareHtml(prepare): '';
			items[i].subjectText = prepare.substr(0, 20);
			items[i].studentIsInDebtText = this.$t(checkBoxToString(items[i].studentIsInDebt)).toString();
			items[i].inPriceListText = this.$t(checkBoxToString(items[i].inPriceList)).toString();
		}
	};
}